import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';

@customElement('model-data-page')
export class ModelDataPage extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0;
			}

			.pageContainer {
				display: flex;
				justify-content: space-between;
				width: 100%;
				gap: 1cqw;
				padding-top: 2cqw;
			}

			.drawing {
				width: 30%
			}

			.dataList {
				width: 70%;
			}

			.imageContainer {
				text-align: center;
				width: 80%;
				margin-left: 0;
				margin-right: auto;
			}

			img {
				max-width: 100%;
			}

			.productImage {
				max-width: 100%;
			}
		`];

	@property({type: Object})
	model = {};

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;
		// console.log('ModelDataPage', this.model);
	}

	render() {
		const s = this.state;
		return html`
			<div class="pageContainer">

				<div class="drawing">
					<div class="imageContainer">
						${when(this.model.model_image, () => html`
							<img class="img" src=${this.model.model_image}/>
						`, () => html``)}
					</div>
					<spc-values-icons attributeKey="root::Heads::Head:Type::Luminaire::LightEngine::LE_LightEngineModuleSize"></spc-values-icons>
					<spc-values-icons attributeKey="root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour"></spc-values-icons>
				</div>

				<div class="dataList">
					<model-data .model="${this.model}"></model-data>
				</div>
			</div>
		`;
	}
}
